import { render, staticRenderFns } from "./DeliveryConfig.vue?vue&type=template&id=78910420&scoped=true"
import script from "./DeliveryConfig.vue?vue&type=script&lang=js"
export * from "./DeliveryConfig.vue?vue&type=script&lang=js"
import style0 from "./DeliveryConfig.vue?vue&type=style&index=0&id=78910420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78910420",
  null
  
)

export default component.exports